class LocalData {
  // 本地储存的所有数据的键，以及其默认值
  dataKeys = {
    LoginStatus: 0,       // 登录状态：-1为已退出登录0未登录1为guest登录2为已登录，仅为0时才发起网页授权登录
    CID: '',              // 客户端ClientId，用于标识访问来源
    SessId: null,         // 会话凭据
    UserData: {},         // 用户资料
    UserRoles: [],        // 用户角色数据
    debugMode: false      // 是否开启服务端远程调试模式
  }

  /**
   * 获取数据
   *
   * @param   {String}  dataKey       要获取的数据的键
   * @param   {mixed}   defaultData   默认值
   * @returns {mixed}
   */
  get (dataKey, defaultData = null) {
    if (Object.keys(this.dataKeys).includes(dataKey)) {
      const ret = JSON.parse(localStorage.getItem(dataKey))
      return ret || defaultData || this.dataKeys[dataKey]
    } else {
      return null
    }
  }

  /**
   * 设置数据
   *
   * @param   {String}  dataKey   要设置的数据的键
   * @param   {mixed}   data      要设置的数据的值
   * @returns {mixed}
   */
  set (dataKey, data = null) {
    if (Object.keys(this.dataKeys).includes(dataKey)) {
      if (data === undefined) {
        data = this.dataKeys[dataKey]
      }
      localStorage.setItem(dataKey, JSON.stringify(data))
      return data
    } else {
      return null
    }
  }

  /**
   * 清除数据
   *
   * @param   {String}   dataKey  要清除的数据的键
   * @returns {mixed}
   */
  remove (dataKey) {
    if (Object.keys(this.dataKeys).includes(dataKey)) {
      localStorage.removeItem(dataKey)
      return this.dataKeys[dataKey]
    } else {
      return null
    }
  }

  /**
   * 清除所有本地储存
   *
   * @returns {Boolean}
   */
  clearup () {
    for (const key in this.dataKeys) {
      this.remove(key)
    }
    return true
  }
}

export default new LocalData()
